import axios from 'axios';

const getBaseURL = () => {
  // 优先使用 .env 中配置的 API 地址
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  // 生产环境走相对路径（由 Caddy/Nginx 代理），开发环境走 proxy
  return '/api';
};

const request = axios.create({
  baseURL: getBaseURL(),
  timeout: 30000,
});

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    // 从localStorage获取token
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      
      if (status === 401) {
        // token过期或未登录
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      } else if (status === 403) {
        // 无权限
        console.error('无权限访问');
      } else if (status === 404) {
        console.error('接口不存在');
      } else {
        console.error('服务器错误:', data.message);
      }
      
      return Promise.reject(data);
    }
    
    return Promise.reject(error);
  }
);

export default request;
